import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  proposalItems: [],
  proposalItemsInit: [],
  zones: [],
  zoneItems: [],
  proposalTourPlan: [],
  fees: [],
  transactionFee: [],
  packingMaterials: [],
  packingMaterialsInit: [],
  totalAmount: 0,
  totalCapacity: 0,
};

const generateUniqueKey = () => {
  const randomNumber = Math.floor(10000 + Math.random() * 90000) + Date.now();
  return randomNumber;
};

const checkObjectIsEmpty = (item) => {
  if (item.gegenstand == undefined || isNaN(item.gegenstand) || item.gegenstand == "" || item.gegenstand == null) {
    console.log("111");
    return true;
  } else {
    if (
      !item.demontage_checked &&
      !item.montage_checked &&
      !item.einpacken_checked &&
      !item.luftpolsterfol_checked &&
      !item.auspacken_checked &&
      !item.entsorgen_checked &&
      !item.einlagern_checked &&
      !item.schwergut_checked &&
      !item.nicht_zerlegbar_checked &&
      (item.entladen === 0 ||
        item.entladen == undefined ||
        isNaN(item.entladen) ||
        item.entladen == "" ||
        item.entladen == "") &&
      (item.gegenstand == undefined || isNaN(item.gegenstand) || item.gegenstand == "" || item.gegenstand == null)
    ) {
      console.log("222");
      return true;
    } else {
      console.log("333");
      return false;
    }
  }
};

const calProposalItemTotal = (item, fee, transactionFee) => {
  console.log(item, fee, transactionFee);
  if (fee.length > 0 && transactionFee.length > 0) {
    const gegenstand = item?.gegenstand ? item?.gegenstand * 1 : 0;
    const demontage = item?.demontage_checked ? 1 : 0;
    const montage = item?.montage_checked ? 1 : 0;
    const einpacken = item?.einpacken_checked ? 1 : 0;
    const luftpolsterfol = item?.luftpolsterfol_checked ? 1 : 0;
    const auspacken = item?.auspacken_checked ? 1 : 0;
    const entsorgen = item?.entsorgen_checked ? 1 : 0;
    const schwergut = item?.schwergut_checked ? 1 : 0;
    const einlagern = item?.einlagern_checked ? 1 : 0;

    const itemTotalAmount =
      gegenstand * item?.volume * fee[0]?.beladen_euro_m3 * 1 +
      (item?.villanyszerelo == true
        ? gegenstand * demontage * item?.szetszerelesi_ido * fee[0]?.kuchenmonteur_euro_std
        : 0) +
      //
      (item?.konyhaszerelo == true
        ? gegenstand * demontage * item?.szetszerelesi_ido * fee[0]?.kuchenmonteur_euro_std * 1
        : 0) +
      //
      gegenstand * demontage * item?.szetszerelesi_ido * fee[0]?.de_und_remontage_euro_std * 1 +
      //
      (item?.villanyszerelo == true
        ? gegenstand * montage * item?.osszeszerelesi_ido * fee[0]?.kuchenmonteur_euro_std * 1
        : 0) +
      //
      (item?.konyhaszerelo == true
        ? gegenstand * montage * item?.osszeszerelesi_ido * fee[0]?.kuchenmonteur_euro_std * 1
        : 0) +
      //
      gegenstand * montage * item?.osszeszerelesi_ido * fee[0]?.de_und_remontage_euro_std * 1 +
      //
      (gegenstand * einpacken * (item?.csomagolasi_ido * 1) +
        gegenstand * luftpolsterfol * (item?.buborekcsomagolasi_ido * 1) +
        gegenstand * auspacken * (item?.kicsomagolasi_ido * 1)) *
        //
        (fee[0]?.auspacken_euro_m3 * 1 +
          gegenstand * (item?.volume * 1) * entsorgen * (fee[0]?.entsorgung_handling * 1)) +
      gegenstand * parseFloat(item?.volume) * einlagern * fee[0]?.lagerentgelt_je * 1 +
      gegenstand * schwergut * fee[0]?.zuschlag_schwergut * 1;

    //

    return itemTotalAmount.toFixed(2);
  }
};

function handleItemChange(state, action, propertyName) {
  const locationId = action.payload.locationId;
  const updatedItem = action.payload.updatedItem;

  if (propertyName === "entsorgen_checked") {
    // updatedItem.demontage_checked = false;
    // updatedItem.montage_checked = false;
    // updatedItem.einpacken_checked = false;
    // updatedItem.luftpolsterfol_checked = false;
    // updatedItem.auspacken_checked = false;
    // updatedItem.einlagern_checked = false;
    // updatedItem.schwergut_checked = false;
    // updatedItem.nicht_zerlegbar_checked = false;

    const itemTotalAmount = calProposalItemTotal(updatedItem, state.fees, state.transactionFee);
    let prTotalAmount = 0;
    let prTotalCapacity = 0;

    state.proposalItems.forEach((location) => {
      if (location.locationId === locationId) {
        let totalAmount = 0;
        let capacity = 0;
        location.items.forEach((item) => {
          if (item.unique_key === updatedItem.unique_key) {
            // Update the property of the found item
            item["demontage_checked"] = updatedItem["demontage_checked"];
            item["montage_checked"] = updatedItem["montage_checked"];
            item["einpacken_checked"] = updatedItem["einpacken_checked"];
            item["luftpolsterfol_checked"] = updatedItem["luftpolsterfol_checked"];
            item["auspacken_checked"] = updatedItem["auspacken_checked"];
            item["einlagern_checked"] = updatedItem["einlagern_checked"];
            item["schwergut_checked"] = updatedItem["schwergut_checked"];
            item["nicht_zerlegbar_checked"] = updatedItem["nicht_zerlegbar_checked"];
            item[propertyName] = updatedItem[propertyName];
            item.zwischensum = itemTotalAmount * 1;
            totalAmount += itemTotalAmount * 1;
            capacity += updatedItem.gegenstand > 0 ? updatedItem.gegenstand * item.volume : 0 * item.volume;
          } else {
            if (item.gegenstand > 0) {
              totalAmount += item.zwischensum * 1;
              capacity += item.gegenstand * item.volume;
            }
          }
        });
        location.capacity = capacity ? parseFloat(capacity).toFixed(2) : 0;
        location.total = totalAmount ? parseFloat(totalAmount).toFixed(2) : 0;
        prTotalAmount = prTotalAmount + totalAmount;
        prTotalCapacity = prTotalCapacity + capacity;
      } else {
        prTotalAmount = parseFloat(prTotalAmount) + parseFloat(location?.total);
        prTotalCapacity = parseFloat(prTotalCapacity) + parseFloat(location?.capacity);
      }
    });
    state.totalAmount = parseFloat(prTotalAmount).toFixed(2);
    state.totalCapacity = parseFloat(prTotalCapacity).toFixed(2);

    if (checkObjectIsEmpty(updatedItem)) {
      state.proposalItemsInit = state.proposalItemsInit.filter((item) => item.unique_key != updatedItem.unique_key);
    } else {
      const updateProposalInitItem = state.proposalItemsInit.find((item) => item.unique_key == updatedItem.unique_key);
      if (!updateProposalInitItem) {
        const capacity = parseFloat(updatedItem.gegenstand) * parseFloat(updatedItem.volume);

        updatedItem.capacity = capacity;
        updatedItem.zwischensum = parseFloat(itemTotalAmount);
        state.proposalItemsInit.push(updatedItem);
      } else {
        updateProposalInitItem["demontage_checked"] = updatedItem["demontage_checked"];
        updateProposalInitItem["montage_checked"] = updatedItem["montage_checked"];
        updateProposalInitItem["einpacken_checked"] = updatedItem["einpacken_checked"];
        updateProposalInitItem["luftpolsterfol_checked"] = updatedItem["luftpolsterfol_checked"];
        updateProposalInitItem["auspacken_checked"] = updatedItem["auspacken_checked"];
        updateProposalInitItem["einlagern_checked"] = updatedItem["einlagern_checked"];
        updateProposalInitItem["schwergut_checked"] = updatedItem["schwergut_checked"];
        updateProposalInitItem["nicht_zerlegbar_checked"] = updatedItem["nicht_zerlegbar_checked"];
        updateProposalInitItem[propertyName] = updatedItem[propertyName];
        updateProposalInitItem.zwischensum = itemTotalAmount;
        const capacity = parseFloat(updatedItem.gegenstand) * parseFloat(updatedItem.volume);
        updateProposalInitItem.capacity = capacity.toFixed(2);
      }
    }
  } else {
    const itemTotalAmount = calProposalItemTotal(updatedItem, state.fees, state.transactionFee);
    let prTotalAmount = 0;
    let prTotalCapacity = 0;

    state.proposalItems.forEach((location) => {
      if (location.locationId === locationId) {
        let totalAmount = 0;
        let capacity = 0;
        location.items.forEach((item) => {
          if (item.unique_key === updatedItem.unique_key) {
            // Update the property of the found item
            item[propertyName] = updatedItem[propertyName];
            item.zwischensum = itemTotalAmount * 1;
            totalAmount += itemTotalAmount * 1;
            capacity += updatedItem.gegenstand > 0 ? updatedItem.gegenstand * item.volume : 0 * item.volume;
          } else {
            if (item.gegenstand > 0) {
              totalAmount += item.zwischensum * 1;
              capacity += item.gegenstand * item.volume;
            }
          }
        });
        console.log(totalAmount);
        location.capacity = capacity ? parseFloat(capacity).toFixed(2) : 0;
        location.total = totalAmount ? parseFloat(totalAmount).toFixed(2) : 0;
        prTotalAmount = prTotalAmount + totalAmount;
        prTotalCapacity = prTotalCapacity + capacity;
      } else {
        prTotalAmount = parseFloat(prTotalAmount) + parseFloat(location?.total);
        prTotalCapacity = parseFloat(prTotalCapacity) + parseFloat(location?.capacity);
      }
    });
    state.totalAmount = parseFloat(prTotalAmount).toFixed(2);
    state.totalCapacity = parseFloat(prTotalCapacity).toFixed(2);
  }
}

const handlePackingMaterialsChange = (state, action) => {
  const locationId = action.payload?.material?.location_id;
  const materialId = action.payload?.material?.id;

  const location = state.packingMaterialsInit.find((location) => location.location_id === locationId);

  if (location) {
    const material = location.materials.find((material) => material.id === materialId);

    if (material) {
      material.gegenstand = action?.payload?.gegenstand * 1;
      material.zwischensum =
        action?.payload?.gegenstand == null
          ? 0
          : parseFloat(action?.payload?.gegenstand * 1 * action?.payload?.material?.ar * 1).toFixed(2);
    }
  }
};

const mapItems = (items, proposal_id, location_id) => {
  return items.map((item) => {
    const uniqueKey = generateUniqueKey();

    return {
      unique_key: uniqueKey,
      id: item?.item_id ? item?.item_id : item?.id,
      zone_id: item.zone_id,
      proposal_id: proposal_id,
      location_id: location_id,
      item_id: item?.item_id ? item?.item_id : item?.id,
      targy_neve: item?.targy_neve,
      dubel_arbeiten: item?.dubel_arbeiten,
      villanyszerelo: item?.villanyszerelo,
      konyhaszerelo: item?.konyhaszerelo,
      volume: item?.volume,
      csomagolasi_ido: item?.csomagolasi_ido,
      buborekcsomagolasi_ido: item?.buborekcsomagolasi_ido,
      kicsomagolasi_ido: item?.kicsomagolasi_ido,
      szetszerelesi_ido: item?.szetszerelesi_ido,
      osszeszerelesi_ido: item?.osszeszerelesi_ido,
      gegenstand: item?.gegenstand ? item?.gegenstand : 0,
      entladen: item?.entladen ? item?.entlade : 0,
      demontage_checked: item?.demontage_checked ? item?.demontage_checked : false,
      montage_checked: item?.montage_checked ? item?.montage_checked : false,
      einpacken_checked: item?.einpacken_checked ? item?.einpacken_checked : false,
      luftpolsterfol_checked: item?.luftpolsterfol_checked ? item?.luftpolsterfol_checked : false,
      auspacken_checked: item?.auspacken_checked ? item?.auspacken_checked : false,
      entsorgen_checked: item?.entsorgen_checked ? item.entsorgen_checked : false,
      einlagern_checked: item?.einlagern_checked ? item?.einlagern_checked : false,
      schwergut_checked: item?.schwergut_checked ? item?.schwergut_checked : false,
      nicht_zerlegbar_checked: item?.nicht_zerlegbar_checked ? item?.nicht_zerlegbar_checked : false,
      zwischensum: item?.zwischensum ? parseFloat(item?.zwischensum).toFixed(2) : 0,
      capacity: item.capacity ? parseFloat(item.capacity).toFixed(2) : 0,
    };
  });
};

const mergeData = (zones, zoneItems, proposalItems, tourPlan) => {
  const mergedDataArray = [];
  const loadedArray = [];
  tourPlan.forEach((tourLocation) => {
    const locationProposalItems = proposalItems.filter((proposalItem) => proposalItem.location_id === tourLocation.id);

    const newZoneItems = zoneItems.filter(
      (zoneItem) => !locationProposalItems.some((proposalItem) => proposalItem.item_id == zoneItem.id)
    );

    const updatedLocationProposalItems = locationProposalItems.map((proposalItem) => {
      const matchingZoneItem = zoneItems.find((zoneItem) => proposalItem.item_id === zoneItem.id);
      if (matchingZoneItem) {
        // Update values in locationProposalItems based on matching zoneItem
        proposalItem.dubel_arbeiten = matchingZoneItem.dubel_arbeiten;
        proposalItem.villanyszerelo = matchingZoneItem.villanyszerelo;
        proposalItem.konyhaszerelo = matchingZoneItem.konyhaszerelo;
        proposalItem.volume = matchingZoneItem.volume;
        proposalItem.csomagolasi_ido = matchingZoneItem.csomagolasi_ido;
        proposalItem.buborekcsomagolasi_ido = matchingZoneItem.buborekcsomagolasi_ido;
        proposalItem.kicsomagolasi_ido = matchingZoneItem.kicsomagolasi_ido;
        proposalItem.szetszerelesi_ido = matchingZoneItem.szetszerelesi_ido;
        proposalItem.osszeszerelesi_ido = matchingZoneItem.osszeszerelesi_ido;
      }
      return proposalItem;
    });

    console.log(locationProposalItems);
    console.log(updatedLocationProposalItems);

    const sumCapacity = locationProposalItems.reduce(
      (sum, proposalItem) => sum + parseFloat(proposalItem.volume * proposalItem.gegenstand || 0),
      0
    );
    const sumZwischensum = locationProposalItems.reduce(
      (sum, proposalItem) => sum + parseFloat(proposalItem.zwischensum || 0),
      0
    );

    console.log(locationProposalItems);
    // Add all items for the current tour location
    const allItems = [...updatedLocationProposalItems, ...newZoneItems];

    const ldItems = mapItems(locationProposalItems, tourLocation?.proposal_id, tourLocation?.id);

    ldItems.map((item) => {
      loadedArray.push(item);
    });

    const mappedItems = mapItems(allItems, tourLocation?.proposal_id, tourLocation?.id);

    mergedDataArray.push({
      locationId: tourLocation?.id,
      total: parseFloat(sumZwischensum).toFixed(2),
      capacity: parseFloat(sumCapacity).toFixed(2),
      items: mappedItems,
    });
  });

  return { mergedDataArray, loadedArray };
};
// Repeat for other change handlers...

const ProposalItemSlice = createSlice({
  name: "proposalItems",
  initialState,
  reducers: {
    setproposalItemsInitial(state, action) {
      const zones = action.payload.zones;
      const zoneItems = action.payload.zoneItems;
      const proposalTourPlan = action.payload.proposalTourPlan;
      const proposalItems = action.payload.proposalItems;
      const fees = action.payload.fees;
      const transactionFee = action.payload.transactionFee;
      const packingMaterials = action.payload.packingMaterials;

      state.zoneItems = zoneItems;
      state.zones = zones;
      state.proposalTourPlan = proposalTourPlan;
      state.fees = fees;
      state.transactionFee = transactionFee;

      const updatePrposalItems = mergeData(zones, zoneItems, proposalItems, proposalTourPlan);

      const sumCapacity = updatePrposalItems.loadedArray.reduce(
        (sum, proposalItem) => sum + 1 * (proposalItem.volume * proposalItem.gegenstand || 0),
        0
      );
      const sumZwischensum = updatePrposalItems.loadedArray.reduce(
        (sum, proposalItem) => sum + 1 * (proposalItem.zwischensum || 0),
        0
      );

      state.totalAmount = parseFloat(sumZwischensum).toFixed(2);
      state.totalCapacity = parseFloat(sumCapacity).toFixed(2);
      state.proposalItems = updatePrposalItems.mergedDataArray;

      console.log(updatePrposalItems.mergedDataArray);

      //packing materials
      const proposalPackingMaterials = action.payload.proposalPackingMaterials;

      const updatedPackingMaterials = proposalTourPlan.map((location) => {
        const pk = packingMaterials.map((material) => {
          const correspondingPkItem = proposalPackingMaterials.find((pkItem) => {
            return material.id == pkItem.packing_material_id && pkItem.location_id == location.id;
          });

          if (correspondingPkItem) {
            return {
              id: material?.id,
              verpackungs_material: material?.verpackungs_material,
              ar: parseFloat(correspondingPkItem?.ar),
              gegenstand: parseFloat(correspondingPkItem?.gegenstand),
              zwischensum: parseFloat(correspondingPkItem.zwischensum),
              location_id: location?.id,
            };
          } else {
            return {
              id: material?.id,
              verpackungs_material: material?.verpackungs_material,
              ar: parseFloat(material?.price),
              gegenstand: 0,
              zwischensum: 0,
              location_id: location?.id,
            };
          }
        });
        return {
          location_id: location?.id,
          materials: pk,
        };
      });

      console.log(updatedPackingMaterials);
      state.packingMaterialsInit = updatedPackingMaterials;
    },

    duplicateItem(state, action) {
      const item = action.payload.product;
      const index = action.payload.index;

      console.log(index);
      const uniqueKey = generateUniqueKey();

      const mappedItem = {
        unique_key: uniqueKey,
        id: item?.item_id ? item?.item_id : item?.id,
        zone_id: item?.zone_id,
        proposal_id: item?.proposal_id,
        location_id: item?.location_id,
        item_id: item?.item_id ? item?.item_id : item?.id,
        targy_neve: item?.targy_neve,
        dubel_arbeiten: item?.dubel_arbeiten,
        villanyszerelo: item?.villanyszerelo,
        konyhaszerelo: item?.konyhaszerelo,
        volume: item?.volume,
        csomagolasi_ido: item?.csomagolasi_ido,
        buborekcsomagolasi_ido: item?.buborekcsomagolasi_ido,
        kicsomagolasi_ido: item?.kicsomagolasi_ido,
        szetszerelesi_ido: item?.szetszerelesi_ido,
        osszeszerelesi_ido: item?.osszeszerelesi_ido,
        gegenstand: 0,
        entladen: 0,
        demontage_checked: false,
        montage_checked: false,
        einpacken_checked: false,
        luftpolsterfol_checked: false,
        auspacken_checked: false,
        entsorgen_checked: false,
        einlagern_checked: false,
        schwergut_checked: false,
        nicht_zerlegbar_checked: false,
        zwischensum: 0,
        capacity: 0,
      };

      let locationIndex = state.proposalItems.findIndex((item) => item.locationId == mappedItem.location_id);

      //state.proposalItemsInit[locationIndex].splice(index + 1, 0, mappedItem);

      state.proposalItems[locationIndex].items.splice(index + 1, 0, mappedItem);
    },

    pushNewItem(state, action) {
      const uniqueKey = generateUniqueKey();
      const item = action.payload;

      state.proposalTourPlan.forEach((tourLocation, index) => {
        const mappedItem = {
          unique_key: uniqueKey,
          id: item?.item_id ? item?.item_id : item?.id,
          zone_id: item?.zone_id,
          proposal_id: tourLocation?.proposal_id,
          location_id: tourLocation?.id,
          item_id: item?.item_id ? item?.item_id : item?.id,
          targy_neve: item?.targy_neve,
          dubel_arbeiten: item?.dubel_arbeiten,
          villanyszerelo: item?.villanyszerelo,
          konyhaszerelo: item?.konyhaszerelo,
          volume: item?.volume,
          csomagolasi_ido: item?.csomagolasi_ido,
          buborekcsomagolasi_ido: item?.buborekcsomagolasi_ido,
          kicsomagolasi_ido: item?.kicsomagolasi_ido,
          szetszerelesi_ido: item?.szetszerelesi_ido,
          osszeszerelesi_ido: item?.osszeszerelesi_ido,
          gegenstand: 0,
          entladen: 0,
          demontage_checked: false,
          montage_checked: false,
          einpacken_checked: false,
          luftpolsterfol_checked: false,
          auspacken_checked: false,
          entsorgen_checked: false,
          einlagern_checked: false,
          schwergut_checked: false,
          nicht_zerlegbar_checked: false,
          zwischensum: 0,
          capacity: 0,
        };
        state.proposalItems[index].items.push(mappedItem);
      });
    },
    gegenstandgegChangeHandler(state, action) {
      handleItemChange(state, action, "gegenstand");
    },

    entladenChangeHandler(state, action) {
      handleItemChange(state, action, "entladen");
    },
    demontageChangeHandler(state, action) {
      handleItemChange(state, action, "demontage_checked");
    },

    montageChangeHandler(state, action) {
      handleItemChange(state, action, "montage_checked");
    },

    einpackenChangeHandler(state, action) {
      handleItemChange(state, action, "einpacken_checked");
    },

    luftpolsterfolChangeHandler(state, action) {
      handleItemChange(state, action, "luftpolsterfol_checked");
    },

    auspackenChangeHandler(state, action) {
      handleItemChange(state, action, "auspacken_checked");
    },

    entsorgenChangeHandler(state, action) {
      handleItemChange(state, action, "entsorgen_checked");
    },

    einlagernChangeHandler(state, action) {
      handleItemChange(state, action, "einlagern_checked");
    },

    schwergutChangeHandler(state, action) {
      handleItemChange(state, action, "schwergut_checked");
    },

    nichtZerlegbarChangeHandler(state, action) {
      handleItemChange(state, action, "nicht_zerlegbar_checked");
    },
    pushNewPackingMaterial(state, action) {
      const newMaterial = action.payload;
      state.packingMaterialsInit.map((location) => {
        location?.materials.push({
          id: newMaterial?.id,
          verpackungs_material: newMaterial?.verpackungs_material,
          ar: parseFloat(newMaterial?.price),
          gegenstand: 0,
          zwischensum: 0,
        });
      });
    },
    packingMtGegenstandChangeHandler(state, action) {
      handlePackingMaterialsChange(state, action);
    },
  },
});

export const ProposalItemActions = ProposalItemSlice.actions;
export default ProposalItemSlice;
